import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/index',
    redirect: '/dashboard',
  },
  {
    path: '/',
    component: () => import('../layout/MainLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Home.vue'),
        meta: { requiresAuth: true, title: '首页' },
      },
      {
        path: 'carousel',
        name: 'Carousel',
        component: () => import('../views/content/Carousel.vue'),
        meta: { requiresAuth: true, title: '首页轮播图' },
      },
      {
        path: 'gallery',
        name: 'Gallery',
        component: () => import('../views/content/Gallery.vue'),
        meta: { requiresAuth: true, title: '图库更新' },
      },
      {
        path: 'one-click',
        name: 'OneClick',
        component: () => import('../views/content/OneClickCreation.vue'),
        meta: { requiresAuth: true, title: '一键造物更新' },
      },
      {
        path: 'modeling',
        name: 'Modeling',
        component: () => import('../views/content/ModelingCourse.vue'),
        meta: { requiresAuth: true, title: '建模学习' },
      },
      {
        path: 'beginner',
        name: 'Beginner',
        component: () => import('../views/content/BeginnerGuide.vue'),
        meta: { requiresAuth: true, title: '新手入门' },
      },
      {
        path: 'works',
        name: 'Works',
        component: () => import('../views/content/WorksDemo.vue'),
        meta: { requiresAuth: true, title: '作品示范' },
      },
      {
        path: 'cloud-service',
        name: 'CloudService',
        component: () => import('../views/content/CloudService.vue'),
        meta: { requiresAuth: true, title: '云服务' },
      },
      {
        path: 'ai-customer-service',
        name: 'AICustomerService',
        component: () => import('../views/content/AICustomerService.vue'),
        meta: { requiresAuth: true, title: 'AI客服' },
      },
      {
        path: 'ai-image-gen',
        name: 'AIImageGen',
        component: () => import('../views/content/AIImageGen.vue'),
        meta: { requiresAuth: true, title: 'AI生图' },
      },
      {
        path: 'ar-after-sales',
        name: 'ARAfterSales',
        component: () => import('../views/content/ARAfterSales.vue'),
        meta: { requiresAuth: true, title: 'AR智能售后' },
      },
      {
        path: 'software-update',
        name: 'SoftwareUpdate',
        component: () => import('../views/content/SoftwareUpdate.vue'),
        meta: { requiresAuth: true, title: '软件更新' },
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// Navigation Guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isLoggedIn = store.getters.isLoggedIn;

  if (requiresAuth && !isLoggedIn) {
    next('/login');
  } else if (to.path === '/login' && isLoggedIn) {
    next('/');
  } else {
    next();
  }
});

export default router;
